import type { GenericProps } from "../../utilities/genericProps";
import { ROUTES } from "@routing/routes";
import { SUPPORT_EMAIL } from "@/config/supportConfig";

// NOTE: GlobalError is the app-root <AppInsightsErrorBoundary> fallback, so it
// renders OUTSIDE RouterProvider. It must NOT use react-router <Link> or the
// polymorphic <Button to=> (there is no Router context). Use plain navigation:
// window.location.reload() and plain <a href> anchors.
export const GlobalError = (props: GenericProps) => {
    return (
        <div className="min-h-screen flex items-center justify-center bg-base-100 p-4">
            <div className="max-w-xl w-full text-center">
                <h2 className="text-3xl font-bold mb-3 text-neutral">
                    Something went wrong on our end
                </h2>
                <p className="text-lg text-neutral mb-2">
                    We hit an unexpected error. Please try reloading the page —
                    if it keeps happening, contact support and we'll help you
                    out.
                </p>
                {props.children && (
                    <p className="text-base text-gray-500 mb-2">
                        {props.children}
                    </p>
                )}
                <div className="mt-6 flex flex-col sm:flex-row gap-3 justify-center">
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={() => window.location.reload()}
                    >
                        Reload page
                    </button>
                    <a href="/" className="btn btn-outline text-neutral">
                        Go home
                    </a>
                    <a
                        href={ROUTES.SUPPORT}
                        className="btn btn-outline text-neutral"
                    >
                        Contact support
                    </a>
                </div>
                {/* The way out that needs no page of ours: /support mounts the
                    customer chrome, and a crash that started in that chrome
                    would land straight back here. */}
                <p className="mt-4 text-sm text-neutral">
                    Or email us at{" "}
                    <a
                        href={`mailto:${SUPPORT_EMAIL}`}
                        className="link link-primary"
                    >
                        {SUPPORT_EMAIL}
                    </a>
                    .
                </p>
            </div>
        </div>
    );
};
